export const styles = {
  dialogContent: {
    width: '480px',
    padding: '12px 24px 24px 24px',
  },
  createNewButton: {
    width: '100%',
    justifyContent: 'left',
    textTransform: 'none',
    padding: '12px 11px',
    mb: '16px',
  },
  plusIcon: {
    width: '24px',
    height: '24px',
  },
};
